import firebase from "firebase";const config = {
    apiKey: "AIzaSyA8dKseb2A6mj3Dyuinu-Olq3oCfCWwqdg",
    authDomain: "wac-registration.firebaseapp.com",
    databaseURL: "https://wac-registration.firebaseio.com",
    projectId: "wac-registration",
    storageBucket: "wac-registration.appspot.com",
    messagingSenderId: "681293987498"
  };firebase.initializeApp(config);export const ref = firebase.database().ref();export const firebaseAuth = firebase.auth



// WEBPACK FOOTER //
// ./src/config/constants.js